module.exports = __webpack_public_path__ + "media/images/home/flow_p_index_4-60de56751a95a8447795d3dbec0977a8.svg";